import { useState, useEffect } from "react";
import PieChart from '@/charts/PieChart';

export default function TicketsStats({t,tickets,columns}){

    const [ dataStatus, setDataStatus ] = useState([]);
    const [ dataOpen, setDataOpen ] = useState([]);
    const [ dataClosed, setDataClosed ] = useState([]);

    const [ colors ] = useState({
        'warning': 'yellow',
        'primary': 'blue',
        'success': 'green',
        'error': 'red',
        'info' : 'blue',
        'secondary' : 'purple'
    });

    useEffect(() => {

        // by open/closed
        const status = {
            open: 0,
            closed: 0
        };

        // if open, by status
        const open = {
        };

        // if closed, by status
        const closed = {
        };

        if(tickets){

            let ticketStatusInfo;            
            const ticketStatuses = columns?.ticket_status_id?.values;
            const ticketStatusesColors = columns?.ticket_status_id?.colors;

            tickets?.forEach((ticket) => {

                if(ticket?.open){
                    
                    status.open++;

                    if(Object.hasOwn(open,ticket?.ticket_status_id)){
                        open[ticket?.ticket_status_id].value++;                        
                    }
                    else{
                        
                        ticketStatusInfo = ticketStatuses.filter(stat => stat?.id === ticket?.ticket_status_id)?.pop();                                                
                        
                        open[ticket?.ticket_status_id] = {
                            id: 0,
                            value: 1,
                            label: t('tickets.ticket_status_id.'+ticketStatusInfo?.name),                            
                        };     

                        if(Object.hasOwn(ticketStatusesColors,ticketStatusInfo?.id)){
                            open[ticket?.ticket_status_id].color = colors[ticketStatusesColors[ticketStatusInfo?.id]];
                        }
                    }
                }
                else{
                    status.closed++;
                    
                    if(Object.hasOwn(closed,ticket?.ticket_status_id)){
                        closed[ticket?.ticket_status_id].value++;
                    }
                    else{
                        ticketStatusInfo = ticketStatuses.filter(stat => stat?.id === ticket?.ticket_status_id)?.pop();                        
                        closed[ticket?.ticket_status_id] = {
                            id: 0,
                            value: 1,
                            label: t('tickets.ticket_status_id.'+ticketStatusInfo?.name),                            
                        };   

                        if(Object.hasOwn(ticketStatusesColors,ticketStatusInfo?.id)){
                            closed[ticket?.ticket_status_id].color = colors[ticketStatusesColors[ticketStatusInfo?.id]];
                        }                     
                    }
                }
            });            
        }

        const newData = [
            {
                id: 0,
                value: status.open,
                label: t('tickets.chart.open')+' ('+status.open+')',
                color: 'red'
            },
            {
                id: 1,
                value: status.closed,
                label: t('tickets.chart.closed')+' ('+status.closed+')',
                color: 'green'
            }
        ];
        setDataStatus(newData);
        
        const newDataOpen = [];
        Object?.keys(open) && Object?.keys(open)?.forEach((key) => {
            var info = open[key];
            info.label = info.label+' ('+info?.value+')';
            newDataOpen.push(info);
        });        
        setDataOpen(newDataOpen);

        const newDataClosed = [];
        Object?.keys(closed) && Object?.keys(closed)?.forEach((key) => {
            var info = closed[key];
            info.label = info.label+' ('+info?.value+')';
            newDataClosed.push(info);
        });        
        setDataClosed(newDataClosed);

    }, [tickets]);

    return (
        <>
        <div className='rounded border app-border-color-gradient p-2'>
            <div className='text-center font-bold mb-2'>
                {t('tickets.chart.status')}
            </div>
            <PieChart
                data={dataStatus}
                //width={300}
                //height={300}
            />
        </div>
        {
            dataOpen && dataOpen?.length > 0 &&
            <div className='mt-4 rounded border app-border-color-gradient p-2'>
                <div className='text-center font-bold mb-2'>
                    {t('tickets.chart.open')}
                </div>
                <PieChart
                    data={dataOpen}
                    //width={300}
                    //height={300}
                />
            </div>
        }
        {
            dataClosed && dataClosed?.length > 0 &&
            <div className='mt-4 rounded border app-border-color-gradient p-2'>
                <div className='text-center font-bold mb-2'>
                    {t('tickets.chart.closed')}
                </div>
                <PieChart
                    data={dataClosed}
                    //width={300}
                    //height={300}
                />
            </div>
        }
        </>
    );
}